var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 60,
    viewBox: "0 0 82 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13992_47753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.9683 58.788H10.5895C5.29821 58.788 1.06519 54.5975 1.06519 49.3594V10.5975C1.06519 5.35942 5.29821 1.16895 10.5895 1.16895H71.9683C77.2596 1.16895 81.4926 5.35942 81.4926 10.5975V49.3594C81.281 54.5975 77.048 58.788 71.9683 58.788Z",
    fill: "url(#paint0_linear_13992_47753)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.57
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3786 1.37793H9.32031V58.7875H10.3786V1.37793Z",
    fill: "#D8A960"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7558 1.37793H70.6975V58.7875H71.7558V1.37793Z",
    fill: "#D8A960"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1685 47.6839H32.1781L27.7335 42.2363V17.722L32.1781 12.2744H50.1685L54.6132 17.722V42.4458L50.1685 47.6839ZM32.8131 46.6363H49.7452L53.5549 42.0268V18.1411L49.5335 13.322H32.6014L28.7917 17.9316V41.8173L32.8131 46.6363Z",
    fill: "#D8A960"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2792 17.3018H53.9762V18.3494H81.2792V17.3018Z",
    fill: "#D8A960"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2827 29.4541H53.9797V30.5017H81.2827V29.4541Z",
    fill: "#D8A960"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2827 41.3975H53.9797V42.4451H81.2827V41.3975Z",
    fill: "#D8A960"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3682 17.3018H1.06519V18.3494H28.3682V17.3018Z",
    fill: "#D8A960"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3682 29.4541H1.06519V30.5017H28.3682V29.4541Z",
    fill: "#D8A960"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3682 41.3975H1.06519V42.4451H28.3682V41.3975Z",
    fill: "#D8A960"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8324 1.37793H35.7741V12.9017H36.8324V1.37793Z",
    fill: "#D8A960"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7828 1.37793H45.7245V12.9017H46.7828V1.37793Z",
    fill: "#D8A960"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8324 47.2637H35.7741V58.7875H36.8324V47.2637Z",
    fill: "#D8A960"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7828 47.2637H45.7245V58.7875H46.7828V47.2637Z",
    fill: "#D8A960"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M74.5065 59.2071H7.83638C3.81501 59.2071 0.428589 55.8548 0.428589 51.8738V8.08333C0.428589 4.10238 3.81501 0.75 7.83638 0.75H74.5065C78.5279 0.75 81.9143 4.10238 81.9143 8.08333V51.8738C81.9143 56.0643 78.5279 59.2071 74.5065 59.2071ZM7.83638 1.79762C4.44996 1.79762 1.48684 4.52143 1.48684 8.08333V51.8738C1.48684 55.2262 4.23831 58.1595 7.83638 58.1595H74.5065C77.8929 58.1595 80.856 55.4357 80.856 51.8738V8.08333C80.856 4.73095 78.1046 1.79762 74.5065 1.79762H7.83638Z",
    fill: "url(#paint1_linear_13992_47753)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13992_47753",
    x1: 64.1146,
    y1: -4.40062,
    x2: 25.0895,
    y2: 55.3537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#FFCB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5E08F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13992_47753",
    x1: 84.6016,
    y1: -10.3388,
    x2: 6.92165,
    y2: 63.3257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6372,
    stopColor: "#EFAB2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5E08F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13992_47753"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81.4857,
    height: 58.4571,
    fill: "white",
    transform: "translate(0.428589 0.75)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChip);
export default __webpack_public_path__ + "static/media/chip.5d7a6304bf000f181a635492dfa4ad15.svg";
export { ForwardRef as ReactComponent };